import axios from "axios";

async function fetchServerPdf(url, fallbackName) {
  const response = await axios.get(url, { responseType: "blob" });
  const header = response.headers?.["content-disposition"] || "";
  const match = header.match(/filename="?([^";]+)"?/i);
  return { blob: response.data, fileName: match ? match[1] : fallbackName };
}

/** Server-generated sales invoice PDF (the official copy: print, download, email and WhatsApp all use it). */
export function fetchSaleInvoicePdf(saleid) {
  return fetchServerPdf(`/v1/sales/${encodeURIComponent(saleid)}/invoice.pdf`, "invoice.pdf");
}

/** Quotation PDF, drawn by the server in the same layout as the sales invoice. */
export function fetchQuotationPdf(quotationid) {
  return fetchServerPdf(`/v1/quotations/${encodeURIComponent(quotationid)}/pdf`, "quotation.pdf");
}

/** Purchase bill PDF, drawn by the server in the same layout as the sales invoice. */
export function fetchPurchasePdf(purchaseid) {
  return fetchServerPdf(`/v1/purchases/${encodeURIComponent(purchaseid)}/bill.pdf`, "purchase.pdf");
}

/** Debit note PDF for a purchase return, drawn by the server in the same layout as the sales invoice. */
export function fetchPurchaseReturnPdf(returnid) {
  return fetchServerPdf(`/v1/purchase-returns/${encodeURIComponent(returnid)}/note.pdf`, "debit-note.pdf");
}

/** Credit note PDF for a sales return, drawn by the server in the same layout as the sales invoice. */
export function fetchSalesReturnPdf(returnid) {
  return fetchServerPdf(`/v1/sales-returns/${encodeURIComponent(returnid)}/note.pdf`, "credit-note.pdf");
}

export function downloadBlob(blob, fileName) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
